import { injectGlobal } from 'styled-components';

const GlobalStyled = injectGlobal`
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}`;

export default GlobalStyled;
